import { Box, Grid, Step, StepLabel, Stepper } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Confirmation from "./Components/Confirmation";
import EnterDetails from "./Components/EnterDetails";
import UploadDocs from "./Components/UploadDocs";
import {
  cancel,
  clearErrors,
  currentPage,
  errors,
  trusttype,
  getDropdownData,
} from "./features/AppSlice";
import { SARSHeader, ErrorModal,YoutubeEmbed } from "@soqs/common";
import { useEffect } from "react";
import Captcha from "./Components/Captcha";
import React from "react";
import { getVideo } from "./features/API";

const getStepFromPage = (page) => {
  switch (page) {
    case PAGES.EnterDetails:
      return 0;
    case PAGES.TrustAdditionalDetailsIndividuals:
      return 1;
    case PAGES.TrustAdditionalDetailsEntities:
      return 2;
    case PAGES.RequestorDetails:
      return 3;
    case PAGES.Captcha:
      return 4;
    case PAGES.UploadSupportingDocs:
      return 5;
    case PAGES.Confirmation:
      return 6;
    default: {
      return 0;
    }
  }
};

const Pager = ({ page, dispatch }) => {
  switch (page) {
    case PAGES.EnterDetails:
    case PAGES.TrustAdditionalDetailsIndividuals:
    case PAGES.TrustAdditionalDetailsEntities:
    case PAGES.RequestorDetails:
      return <EnterDetails />;
    case PAGES.Captcha:
      return <Captcha />;
    case PAGES.UploadSupportingDocs:
      return <UploadDocs />;
    case PAGES.Confirmation:
      return <Confirmation />;
    default: {
      dispatch(cancel());
    }
  }
};

export const PAGES = {
  EnterDetails: 0,
  TrustAdditionalDetailsIndividuals: 1,
  TrustAdditionalDetailsEntities: 2,
  RequestorDetails: 3,
  Captcha: 4,
  UploadSupportingDocs: 5,
  Confirmation: 6,
};

const StepperWrapper = ({ page, pageState, trustType }) => (
  <>
    <Box sx={{ display: { xs: "block", md: "none" } }}>
      <Stepper activeStep={getStepFromPage(page)}>
        <Step
          key={PAGES.EnterDetails}
          completed={pageState > PAGES.EnterDetails}
        >
          <StepLabel></StepLabel>
        </Step>
        {trustType !== "4" ? (
          <Step
            key={PAGES.TrustAdditionalDetailsIndividuals}
            completed={pageState > PAGES.TrustAdditionalDetailsIndividuals}
          >
            <StepLabel></StepLabel>
          </Step>
        ) : null}
        {trustType !== "4" ? (
          <Step
            key={PAGES.TrustAdditionalDetailsEntities}
            completed={pageState > PAGES.TrustAdditionalDetailsEntities}
          >
            <StepLabel></StepLabel>
          </Step>
        ) : null}
        <Step
          key={PAGES.RequestorDetails}
          completed={pageState > PAGES.RequestorDetails}
        >
          <StepLabel></StepLabel>
        </Step>
        <Step key={PAGES.Captcha} completed={pageState > PAGES.Captcha}>
          <StepLabel></StepLabel>
        </Step>
        <Step
          key={PAGES.UploadSupportingDocs}
          completed={pageState > PAGES.UploadSupportingDocs}
        >
          <StepLabel></StepLabel>
        </Step>
      </Stepper>
    </Box>
    <Box sx={{ display: { xs: "none", md: "block" } }}>
      <Stepper activeStep={getStepFromPage(page)}>
        <Step
          key={PAGES.EnterDetails}
          completed={pageState > PAGES.EnterDetails}
        >
          <StepLabel>Trust Details</StepLabel>
        </Step>
        {trustType !== "4" ? (
          <Step
            key={PAGES.TrustAdditionalDetailsIndividuals}
            completed={pageState > PAGES.TrustAdditionalDetailsIndividuals}
          >
            <StepLabel>Beneficial Owners (Individuals)</StepLabel>
          </Step>
        ) : null}
        {trustType !== "4" ? (
          <Step
            key={PAGES.TrustAdditionalDetailsEntities}
            completed={pageState > PAGES.TrustAdditionalDetailsEntities}
          >
            <StepLabel>Beneficial Owners (Entities)</StepLabel>
          </Step>
        ) : null}
        <Step
          key={PAGES.RequestorDetails}
          completed={pageState > PAGES.RequestorDetails}
        >
          <StepLabel>Requestor Details</StepLabel>
        </Step>
        <Step key={PAGES.Captcha} completed={pageState > PAGES.Captcha}>
          <StepLabel>Captcha</StepLabel>
        </Step>
        <Step
          key={PAGES.UploadSupportingDocs}
          completed={pageState > PAGES.UploadSupportingDocs}
        >
          <StepLabel>Supporting Docs</StepLabel>
        </Step>
      </Stepper>
    </Box>
  </>
);

function App() {
  const dispatch = useDispatch();
  const pageState = useSelector(currentPage);
  const errorState = useSelector(errors);
  const trustType = useSelector(trusttype);

  useEffect(() => {
    dispatch(getDropdownData());
    return () => {};
  });

  return (
    <>
      <SARSHeader
        onLogoClick={() => dispatch(cancel())}
        pageTitle="Trust Registration"
        pageTitleMobile=""
      />

      <div className="App">
        <Grid
          container
          spacing={2}
          style={{
            minHeight: "80vh",
            paddingLeft: "2%",
            paddingRight: "2%",
            justifyContent: "center",
          }}
          alignContent="flex-start"
        >
          <Grid
            size={{ xs: 12 }}
            style={{ paddingTop: "8vh", maxWidth: "1500px" }}
          >
            <StepperWrapper
              page={pageState}
              pageState={pageState}
              trustType={trustType}
            />
          </Grid>

          <Grid
            size={{ xs: 12 }}
            style={{ paddingTop: "2vh", maxWidth: "1500px" }}
          >
            <Pager page={pageState} dispatch={dispatch} />
            <ErrorModal
              title={
                errorState?.errortitle
                  ? errorState?.errortitle
                  : typeof errorState?.error === "string" &&
                      errorState?.error?.indexOf("|") > -1
                    ? errorState?.error?.split("|")[0]
                    : "Error"
              }
              open={errorState !== null}
              onClose={() => {
                if (errorState?.fatal) {
                  dispatch(cancel());
                } else {
                  dispatch(clearErrors());
                }
              }}
              subheader={
                Array.isArray(errorState?.error) ? (
                  <ul>
                    {errorState?.error.map((e, idx) => (
                      <li key={idx}>{e.replace("- ", "")}</li>
                    ))}
                  </ul>
                ) : (
                  <p
                    dangerouslySetInnerHTML={{
                      __html:
                        errorState?.error?.indexOf("|") > -1
                          ? errorState?.error?.split("|")[1]
                          : errorState?.error,
                    }}
                  ></p>
                )
              }
            />
          </Grid>
        </Grid>
        <YoutubeEmbed appCode="TRUST" fetchVideo={getVideo} 
  initialPosition="top-right" 
/>
      </div>
    </>
  );
}

export default App;
